import { useState, useRef } from 'react';
import emailjs from '@emailjs/browser';
import PageHero from '../components/PageHero';

// ── EmailJS config ──────────────────────────────────────────────
// Replace these three values after setting up EmailJS (see README / instructions below)
const EMAILJS_SERVICE_ID  = 'YOUR_SERVICE_ID';
const EMAILJS_TEMPLATE_ID = 'YOUR_TEMPLATE_ID';
const EMAILJS_PUBLIC_KEY  = 'YOUR_PUBLIC_KEY';
// ───────────────────────────────────────────────────────────────

const INFO = [
  {icon:'📧',label:'Email',value:'yojanasaathi@gmail.com'},
  {icon:'🏛️',label:'Organisation',value:'YojanaSaathi'},
  {icon:'🗺️',label:'Coverage',value:'All 28 States of India'},
  {icon:'🕐',label:'Response time',value:'Within 2 business days'},
];

export default function Contact() {
  const formRef = useRef(null);
  const [form, setForm] = useState({name:'',email:'',subject:'',message:''});
  const [status, setStatus] = useState('idle'); // idle | sending | sent | error
  const set = k => e => setForm(f=>({...f,[k]:e.target.value}));

  const handleSubmit = async () => {
    if (!form.name || !form.email || !form.subject || !form.message) {
      alert('Kripya sabhi fields bharen / Please fill all fields.');
      return;
    }
    setStatus('sending');
    try {
      await emailjs.send(
        EMAILJS_SERVICE_ID,
        EMAILJS_TEMPLATE_ID,
        {
          from_name:    form.name,
          from_email:   form.email,
          subject:      form.subject,
          message:      form.message,
          reply_to:     form.email,
        },
        EMAILJS_PUBLIC_KEY
      );
      setStatus('sent');
    } catch (err) {
      console.error('EmailJS error:', err);
      setStatus('error');
    }
  };

  return (
    <>
      <PageHero tag="Get In Touch · संपर्क करें" title="We're Here to Help" subtitle="कोई सवाल है? हम मदद के लिए यहाँ हैं।" from="#CC6600" to="#FF9933" tagColor="rgba(255,255,255,.9)" />

      <section className="section section-gray">
        <div className="wrap">
          <div className="contact-grid">
            <div>
              <p className="contact-intro">Have a question? Reach out for partnerships, media enquiries, or general assistance.</p>
              {INFO.map(item=>(
                <div key={item.label} className="contact-info-item">
                  <span className="ico">{item.icon}</span>
                  <div>
                    <div className="lbl">{item.label}</div>
                    <div className="val">{item.value}</div>
                  </div>
                </div>
              ))}
            </div>

            <div className="form-box">
              {status === 'sent' ? (
                <div className="success-box">
                  <div className="ico">✅</div>
                  <h3>Message Sent!</h3>
                  <p>Thank you for reaching out. We'll get back to you within 2 business days.</p>
                </div>
              ) : (
                <>
                  <h3>Send Us a Message</h3>
                  <div className="form-fields" ref={formRef}>
                    {[
                      {k:'name',l:'Full Name',p:'Your name',t:'text'},
                      {k:'email',l:'Email Address',p:'your@email.com',t:'email'},
                      {k:'subject',l:'Subject',p:'What is this about?',t:'text'},
                    ].map(f=>(
                      <div key={f.k} className="form-field">
                        <label>{f.l}</label>
                        <input type={f.t} placeholder={f.p} value={form[f.k]} onChange={set(f.k)} />
                      </div>
                    ))}
                    <div className="form-field">
                      <label>Message</label>
                      <textarea rows={4} placeholder="Tell us how we can help..." value={form.message} onChange={set('message')} />
                    </div>
                    {status === 'error' && (
                      <p style={{color:'red',fontSize:13,margin:'4px 0'}}>
                        Kuch galat hua. Dobara try karein ya seedha email karein: yojanasaathi@gmail.com
                      </p>
                    )}
                    <button
                      className="btn btn-navy btn-full"
                      style={{fontSize:15}}
                      onClick={handleSubmit}
                      disabled={status === 'sending'}
                    >
                      {status === 'sending' ? 'Sending…' : 'Send Message →'}
                    </button>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
